import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderInner from "./HeaderInner";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Button, TextField } from "@material-ui/core";
import configureStore from "../../../store/configureStore";
import { create_task } from "./actions/action-task";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Footer from "./Footer";
import { get_lead, get_lead_details } from "./actions/action-lead";
import { history } from "../../..//reducers";
import CommonSnackBar from "../../common/CommonSnackBar";

const store = configureStore();

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 10,
  },
  input: {
    marginBottom: 10,
    background: "#fff",
    width: "100%",
  },
  Select: {
    marginBottom: 10,
    background: "#fff",
    width: "100%",
  },
  formControl: {
    marginBottom: 10,
    background: "#fff",
    width: "100%",
  },
}));

export default function AddTask() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { activeOuid, activeOuidChain } = store.getState().permission;
  const { tasks, showGlobalLoader } = store.getState().task;
  const { leads } = useSelector((state) => state.lead);
  const { leaddetails } = useSelector((state) => state.lead);

  const [state, setState] = React.useState({
    leadId: "",
    leadContactFullName: "",
    taskDetail: "",
    taskDateTime: "",
  });

  const renderLead = (leadItems) => {
    if (leadItems) {
      return leadItems.map((item) => (
        <MenuItem
          className={classes.MenuItem}
          key={item.id}
          value={item.id}
          data-my-value={item.contactFullName}
        >
          {item.contactFullName}
        </MenuItem>
      ));
    }
  };

  const onSelectChange = (event) => {
    console.log("event", event);
    const { myValue } = event.currentTarget.dataset;
    console.log("Menu click event", myValue);
    // setState({ ...state, lead: event.target.value });
    setState({
      ...state,
      leadId: event.target.value,
      leadContactFullName: myValue,
    });
    console.log("state", state);
  };

  const handleDatetimeChange = (event) => {
    var myString = event.target.value;
    myString = myString.replace(/[^\d]/g, "");
    myString = Number(myString);
    setState({ ...state, [event.target.id]: myString });
  };

  const handleChange = (event) => {
    setState({ ...state, [event.target.id]: event.target.value });
    console.log("task", state);
  };

  const handleSubmit = () => {
    console.log("Handle submit");
    dispatch(create_task(state, activeOuid));
    history.push(`/${activeOuid}/tasks`);
  };

  let search = window.location.search;
  let params = new URLSearchParams(search);
  let particularId = params.get("leadid");
  console.log("particularId", particularId);

  useEffect(() => {
    const fetchData = async (dispatch) => {
      if (particularId) {
        await dispatch(get_lead_details(particularId, activeOuid));
        setState({
          ...state,
          leadId: store.getState().lead.leaddetails.id,
          leadContactFullName:
            store.getState().lead.leaddetails.contactFullName,
        });
      } else {
        await dispatch(get_lead(activeOuid));
      }
    };
    fetchData(dispatch);
    console.log("leads", leads);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Create Task" />
      <div className="HrmAppPage container--narrow mt">
        <p className="sub_text">Link Contact*</p>

        <form className="add_wrap" onSubmit={() => handleSubmit()}>
          {particularId ? (
            <TextField
              id="leadContactFullName"
              label="Full Name"
              fullWidth
              required
              disabled
              value={leaddetails && leaddetails.contactFullName}
              variant="outlined"
              className={classes.input}
              onChange={handleChange}
              inputProps={{
                style: {
                  textTransform: "capitalize",
                  color: "#131313",
                },
              }}
            />
          ) : (
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="demo-simple-select-outlined-label">
                Full Name
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="leadContactFullName"
                required
                value={state.leadId && state.leadId}
                onChange={onSelectChange}
                label="Full Name"
                className={classes.select}
              >
                {leads && renderLead(leads)}
              </Select>
            </FormControl>
          )}

          <h4 className="form_heading">Task Details</h4>
          <TextField
            id="taskDetail"
            label="Description"
            fullWidth
            required
            variant="outlined"
            className={classes.input}
            onChange={handleChange}
          />

          <TextField
            id="taskDateTime"
            required
            // defaultValue={new Date().toISOString().slice(0, 16)}
            inputProps={{
              // min: "2021-02-20T00:00",
              min: new Date().toISOString().slice(0, 16),
            }}
            fullWidth
            variant="outlined"
            label="Date and time"
            placeholder="Select Date and Time"
            type="datetime-local"
            className={classes.input}
            onChange={handleDatetimeChange}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <div className="AppFloatingButtonWrapper t-c">
            <Button
              type="submit"
              className="primary_btn"
              fullWidth
              variant="contained"
              color="primary"
              // onClick={() => handleSubmit()}
            >
              Create Task
            </Button>
          </div>
        </form>
      </div>
      <Footer />
      <CommonSnackBar />
    </div>
  );
}
